import { atom, selector } from 'recoil'
import stringUtils from '../utils/stringUtils'
import { accessTokenState } from './authenticationState'
import { STATION_CONFIG_TYPE } from '../constant'

export const provinceState = atom({
  key: 'provinceState',
  default: [],
})
export const districtState = atom({
  key: 'districtState',
  default: [],
})
export const wardsState = atom({
  key: 'wardsState',
  default: [],
})
export const branchState = atom({
  key: 'branchState',
  default: [],
})
export const pageConfigState = atom({
  key: 'pageConfigState',
  default: {},
})
export const pageStatusListState = atom({
  key: 'pageStatusListState',
  default: [],
})
export const pageStatusState = selector({
  key: 'pageStatusState',
  get: ({ get }) => {
    const pageStatusList = get(pageStatusListState)
    return pageStatusList?.length > 0 ? pageStatusList?.find(e => e?.pageType === 'STATION') : 'OFF'
  },
})
export const pageConfigRealState = selector({
  key: 'pageConfigRealState',
  get: ({ get }) => {
    const pageConfig = get(pageConfigState)
    return pageConfig?.length > 0 ? pageConfig?.find(e => e?.status === STATION_CONFIG_TYPE.REAL) : {}
  },
})
export const pageConfigDraftState = selector({
  key: 'pageConfigDraftState',
  get: ({ get }) => {
    const pageConfig = get(pageConfigState) || []

    if (!Array.isArray(pageConfig) || pageConfig.length === 0) return {}

    const draft = pageConfig.find(e => e?.status === STATION_CONFIG_TYPE.DRAFT)
    const wait = pageConfig.find(
      e => e?.status === STATION_CONFIG_TYPE.WAITING_FOR_APPROVE,
    )
    const real = pageConfig.find(e => e?.status === STATION_CONFIG_TYPE.REAL)

    return draft || wait || real || {}
  },
})